import { renderLocationDetails } from '@/features/Scan/utils';

const LocationScanActionCard = ({ locationResponseFromLocationScan, onShowLocationModal }) => {
	const { locationResponse, productResponsePage } = locationResponseFromLocationScan;

	return (
		<div className="folder-column-card-view mb-12 border">
			<div>
				{!locationResponse?.isFound && <span className="status red-2 mt-1">Location Not found</span>}
				<p className="regular-12 gray_dark_02 mt-2">
					Location ID:{' '}
					<span className="gray_dark_01 weight-700"> {locationResponse?.locationId}</span>
					<p className="blue cursor-pointer regular-14" onClick={() => onShowLocationModal(true)}>
						{locationResponse?.isFound ? 'Edit' : 'Add this new location'}
					</p>
				</p>
				{locationResponse && (
					<p className="regular-14 gray_dark_02 mt-1">
						{locationResponse?.countryResponse?.code}
						{renderLocationDetails(locationResponse, 'buildingTagResponse')}
						{renderLocationDetails(locationResponse, 'floorTagResponse')}
						{renderLocationDetails(locationResponse, 'roomOrAreaTagResponse')}
						{renderLocationDetails(locationResponse, 'colorTagResponse')}
						{locationResponse?.otherDetails && `${`, ${locationResponse?.otherDetails}`}`}
					</p>
				)}

				{!locationResponse?.isReplaced && locationResponse?.isFound && (
					<span className="status yellow-2 mt-1">
						{productResponsePage?.totalElements > 0 || locationResponse?.count > 0
							? `${productResponsePage?.totalElements || locationResponse?.count} Styles found in this location`
							: 'No styles found in this location'}
					</span>
				)}
				{locationResponse?.isReplaced && (
					<span className="status yellow-2 mt-1">
						{`${productResponsePage?.totalElements} Styles Replaced in this location`}
					</span>
				)}
			</div>
		</div>
	);
};

export default LocationScanActionCard;
